import axios from '@/core/axios'
import { Customer } from 'stoux-shared-types/models/customer'

import { RegisterDto, RegisterResponse } from '../dtos/register.dto'
import { SignInDto, SignInResponse } from '../dtos/sign-in.dto'

export class AuthenticationRepository {
    public async signIn(dto: SignInDto): Promise<Customer> {
        const { data } = await axios.post<SignInResponse>('/auth', dto)
        return data.customer
    }

    public async register(dto: RegisterDto): Promise<Customer> {
        const { data } = await axios.post<RegisterResponse>('/customers', dto)
        return data.customer
    }

    public async getUserLoggedIn(): Promise<Customer | null> {
       try {
        const { data } = await axios.get<SignInResponse>('/customers/me')
        return data.customer
       } catch (error) {
            return null
       }
    }

    public async deleteSession(): Promise<void> {
        await axios.delete('/auth')
    }
}
